/* Velezeco - conserto do Remove no carrinho.  2026-09-27

   O PROBLEMA
   Os pares do bundle sao a MESMA variante, entao a Shopify junta tudo numa linha
   so. Quando o desconto "compre 1 leve 2" entra, ela QUEBRA essa linha em duas:
   a paga e a de preco zero.

   O Remove do tema mandava "quantity=0" para a linha clicada, o que apagava a
   FATIA inteira de uma vez: clicar na fatia gratuita tirava 2 pares de um golpe,
   e como a Shopify reaplicava o desconto e quebrava tudo de novo, o carrinho
   parecia se mexer sozinho.

   A REGRA (pedido do Simon)
   Cada clique em Remove tira UMA unidade. Nao a fatia, nao o conjunto.

   COMO
   Lemos a quantidade atual da linha clicada e mandamos `cart/change.js` com
   quantidade menos um. A chave de linha e recalculada a cada mudanca do
   carrinho, mas isso nao e problema aqui: ela so precisa ser valida no instante
   do pedido, e nos acabamos de le-la.

   TENTATIVA QUE NAO DEU CERTO, registrada para ninguem repetir:
   usar `cart/update.js` com `updates` indexado por ID DE VARIANTE e a quantidade
   total. A Shopify aplica esse numero POR LINHA, nao como total, entao com a
   linha quebrada em duas cada clique AUMENTAVA o carrinho. Medido: 3 pares
   viraram 4, depois 6, depois 9, depois 14.

   VELOCIDADE
   A linha clicada apaga e trava na hora, antes da rede responder, porque sem
   sinal nenhum o cliente clicava de novo achando que estava quebrado. E o
   cart:change reaproveita o carrinho que o change.js ja devolveu, em vez de
   gastar outra ida a rede so para o script do brinde reavaliar.

   Nao mexemos no menos/mais da quantidade: ali o comportamento ja estava certo. */
(function () {
  if (window.__vzCartRemoveFix) return; window.__vzCartRemoveFix = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ocupado = false;

  function chaveDoLink(a) {
    var href = a.getAttribute('href') || '';
    if (!/[?&]quantity=0(&|$)/.test(href)) return null;   // so o Remove
    var m = href.match(/[?&]id=([^&]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href*="/cart/change"]');
    if (!a) return;
    var chave = chaveDoLink(a);
    if (!chave) return;

    ev.preventDefault();
    ev.stopPropagation();
    if (ocupado) return;
    ocupado = true;

    var linha = a.closest('.cart-line-item, [class*="line-item"], li, tr') || a.parentElement;
    if (linha) { linha.style.opacity = '.45'; linha.style.pointerEvents = 'none'; }

    function solta() {
      ocupado = false;
      if (linha) { linha.style.opacity = ''; linha.style.pointerEvents = ''; }
    }

    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var alvo = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === chave) { alvo = cart.items[i]; break; }
        }
        // chave ja vencida: tira uma unidade da primeira linha da mesma variante
        if (!alvo) {
          var vid = String(chave).split(':')[0];
          for (var j = 0; j < cart.items.length; j++) {
            if (String(cart.items[j].variant_id) === vid) { alvo = cart.items[j]; break; }
          }
        }
        if (!alvo) return null;

        return fetch(ROOT + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: alvo.key, quantity: alvo.quantity - 1 })
        }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        // 'line-item:change' avisa que quem mexeu foi o CLIENTE. O script do
        // brinde usa isso: se o que saiu foi o proprio brinde, ele entende como
        // recusa e nao recoloca.
        document.dispatchEvent(new CustomEvent('line-item:change', { bubbles: true }));
        // 'cart:refresh' manda o tema redesenhar a gaveta.
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'vz-remove' } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        // Passamos por fora do handler do tema, entao o 'cart:change' dele nao
        // dispara. Reaproveitamos o carrinho que o change.js ja devolveu.
        if (cart.items) {
          document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
        }
      })
      .catch(function () { window.location.href = a.getAttribute('href'); })
      .finally(solta);
  }, true);   // captura, para chegar antes do handler do tema
})();
